import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessListFairProduct} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessListFairProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MyBusinessListFairProductPage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business-news'>
        <MyBusinessListFairProduct params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessListFairProductPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessListFairProductPage.jsx